import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Stepper from '../../component/stepper/Stepper';
import { setItem, getItem } from '../../config/localStorage';
import ChangeTemplateLayout from '../../component/changetemplate/ChangeTemplateLayout';
import { axiosInstance } from '../../config/ConfigInfo';
import moment from 'moment';
import PreviewTemplate from '../../component/preview/PreviewTemplate';
import SpinLoader from '../../component/loader/SpinLoader';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function History() {
    const getExpData = getItem('experienceData') ? JSON.parse(getItem('experienceData')) : '';
    const chossenExperienceNeedResumeType = getItem('experienceNeedResumeType');
    const [choosenHistoryType, setChoosenHistoryType] = useState(chossenExperienceNeedResumeType ?? 'job-seeking');
    const [fresherData, setFresherData] = useState(JSON.parse(getItem('fresherData')) === true ? JSON.parse(getItem('fresherData')) : false);
    const [historyOne, setHistoryOne] = useState(true);
    const [historyTwo, setHistoryTwo] = useState(false);
    const [historyThree, setHistoryThree] = useState(false);
    const [loader, setLoader] = useState(true);
    const [experience, setExperience] = useState(
        getExpData ??
        [{
            jobTitle: '',
            jobDescription: '',
            employer: '',
            location: '',
            startDate: '',
            endDate: '',
            currentlyWorkHere: false
        }]
    );
    const location = useLocation();
    const navigate = useNavigate();

    /** to handle next and previous click button start */

    useEffect(() => {

        if (location.state === null) {
            navigate('/resume-builder');
        } else {
            if (location.state.experienceTabOne === true) {
                HistoryFieldsOne();
            }
            if (location.state.experienceTabThree === true) {
                HistoryFieldsThree();
            }
        }

        /** call API to fetch the experience data start */
        (async () => {

            if (!getExpData) {
                try {
                    const { data } = await axiosInstance.get("api/JobSeeker/GetJobSeekerExperience");

                    if (data?.data?.expTypeName === "Experienced") {
                        setFresherData(false)
                    } else {
                        setFresherData(true)
                    }
                    if (data.status === 200) {
                        const formattedData = data.data.jobsekerExps.map(item => ({
                            jobTitle: item.jobTitle,
                            jobDescription: item.jobDescription,
                            employer: item.companyName,
                            location: item.location ?? 'N/A',
                            startDate: item.startDate,
                            endDate: item.endDate,
                            currentlyWorkHere: item.currentEmployee
                        }));
                        setExperience(formattedData);
                        setLoader(false);
                    }
                } catch (error) {
                    setLoader(false);
                }
            } else {
                setLoader(false);
            }
        })()
        /** call API to fetch the experience data end */

    }, []);


    const MovetoEducationPage = () => {
        if (fresherData) {
            setItem('experienceData', null);
            navigate('/education', { state: { educationTabOne: true } });
        } else {
            const checkValidation = formValidation(experience);
            if (checkValidation) {
                const jsonData = JSON.stringify(experience);
                setItem('experienceData', jsonData);
                navigate('/education', { state: { educationTabOne: true } });
            }
        }
    }

    /** Check validation required fields start */
    const formValidation = (experience) => {
        let data = [...experience];
        let validationCheck = true;

        for (let i = 0; i < data.length; i++) {

            const { jobTitle, employer, location, jobDescription, startDate, endDate, currentlyWorkHere } = data[i];

            if (!jobTitle) {
                data[i].errorJobTitleMsg = 'Enter the job title.';
                validationCheck = false;
            } else if (jobTitle && jobTitle.length > 40) {
                data[i].errorJobTitleMsg = 'Job title should not exceed 40 characters.';
                validationCheck = false;
            } else {
                data[i].errorJobTitleMsg = '';
            }

            if (!employer) {
                data[i].errorEmployerMsg = 'Enter the organization name.';
                validationCheck = false;
            } else if (employer && employer.length > 40) {
                data[i].errorEmployerMsg = 'Organization name should not exceed 40 characters.';
                validationCheck = false;
            } else {
                data[i].errorEmployerMsg = '';
            }

            if (!location) {
                data[i].errorLocationMsg = 'Enter the location.';
                validationCheck = false;
            } else if (location && location.length > 40) {
                data[i].errorLocationMsg = 'Location name should not exceed 40 characters.';
                validationCheck = false;
            } else {
                data[i].errorLocationMsg = '';
            }

            if (jobDescription && jobDescription.length > 400) {
                data[i].errorjobDescriptionMsg = 'Job Description information should not exceed 400 characters.';
                validationCheck = false;
            } else {
                data[i].errorjobDescriptionMsg = '';
            }

            if (!startDate) {
                data[i].errorStartDateMsg = 'Select the start date.';
                validationCheck = false;
            } else {
                data[i].errorStartDateMsg = '';
            }

            if (!currentlyWorkHere && (!endDate || endDate === null)) {
                data[i].errorEndDateMsg = 'Select the end date.';
                validationCheck = false;
            } else if ((Date.parse(endDate) <= Date.parse(startDate))) {
                data[i].errorEndDateMsg = 'End date should be greater than Start date.';
                validationCheck = false;
            } else {
                data[i].errorEndDateMsg = '';
            }

            if (currentlyWorkHere) {
                data[i].endDate = null;
            }
        }
        setExperience(data);
        return validationCheck;
    };


    /** Check validation required fields end */

    const BackProfilePage = () => {
        navigate('/profile', { state: { profilePaage: true } });
    }

    /** to handle next and previous click button end */

    const handelExperienceAdd = () => {
        const newExperience = [...experience, { jobTitle: '', jobDescription: '', employer: '', location: '', startDate: '', endDate: '', currentlyWorkHere: false }];
        setExperience(newExperience);
    }

    const handelExperienceRemove = (index) => {
        const newExperience = [...experience];
        newExperience.splice(index, 1);
        setExperience(newExperience);
    }

    const handleChange = (index, nameOrEvent, value) => {
        let name, newValue;
        if (typeof nameOrEvent === 'string') {
            // DatePicker case
            name = nameOrEvent;
            const formattedDate = value.toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            newValue = formattedDate;
        } else {
            // Input element case
            name = nameOrEvent.target.name;
            newValue = nameOrEvent.target.type === 'checkbox' ? nameOrEvent.target.checked : nameOrEvent.target.value;
        }
        const newExperience = [...experience];
        newExperience[index][name] = newValue;
        if (name === 'startDate') {
            newExperience[index][name] = value;
            newExperience[index]['endDate'] = '';
        }
        if (name === 'currentlyWorkHere') {
            newExperience[index]['endDate'] = '';
        }
        setExperience(newExperience);
        validationOnChange(name, newExperience);
    };

    const validationOnChange = (name, newExperience) => {
        let data = [...newExperience];
        for (let i = 0; i < data.length; i++) {
            if (name === "jobTitle" && data[i].jobTitle !== '') {
                delete data[i].errorJobTitleMsg;
            }
            if (name === "employer" && data[i].employer !== '') {
                delete data[i].errorEmployerMsg;
            }
            if (name === "location" && data[i].location !== '') {
                delete data[i].errorLocationMsg;
            }
            if (name === "startDate" && data[i].startDate !== '') {
                delete data[i].errorStartDateMsg;
            }
            if (name === "endDate" && data[i].endDate !== '') {
                delete data[i].errorEndDateMsg;
            }
            if (name === "jobDescription" && data[i].jobDescription !== '') {
                delete data[i].errorjobDescriptionMsg;
            }
        }
        return data;
    }

    /** fresher handel start */
    const handelFresher = (event) => {
        if (event.target.checked === true) {
            setFresherData(true);
            setItem('experienceData', null);
            setItem('jobTitle', null);
            setItem('fresherData', true);
        } else {
            setFresherData(false);
            setItem('fresherData', false);
        }
    }
    /** fresher handel end */

    const HistoryFieldsOne = (e) => {
        setHistoryOne(true);
        setHistoryTwo(false);
        setHistoryThree(false);
    }

    const HistoryFieldsTwo = (e) => {
        setHistoryOne(false);
        setHistoryTwo(true);
        setHistoryThree(false);
        setItem("experienceNeedResumeType", choosenHistoryType);
    }

    const HistoryFieldsThree = (e) => {
        setHistoryOne(false);
        setHistoryTwo(false);
        setHistoryThree(true);
    }

    const onOptionChange = (e) => {
        setChoosenHistoryType(e.target.value);
    }

    /* To get the jobtitle based on the experience start */
    if (experience && fresherData === false) {
        const jobTitles = experience?.map((item) => item.jobTitle);
        const jobTitlesString = jobTitles.join(', ');
        setItem('jobTitle', jobTitlesString);
    } else {
        setItem('jobTitle', '');
    }
    /* To get the jobtitle based on the experience end */

    const handleKeyDown = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <section className='main-section padding-top-bottom history-main-section'>

                <Container>
                    <Row>
                        <Col md={12}>
                            <Card className='history-card-option shadow border-0'>
                                <Stepper pagenumber='2' />

                                {
                                    historyOne ?
                                        <Card.Body>
                                            <Row>
                                                <Col md={2}></Col>
                                                <Col md={8}>
                                                    <Col md={12} className='histrory-header-part'>
                                                        <Card.Title>Why do you need a resume?</Card.Title>
                                                        <Card.Text>A resume is essential for showcasing your skills, experience, and qualifications, whether you're job seeking or pursuing other professional opportunities.</Card.Text>

                                                    </Col>
                                                    <Col md={12}>
                                                        <div className='history-main'>

                                                            <div className="history-outer">
                                                                <input type="radio"
                                                                    id="job-seeking"
                                                                    name="choosen-history-type"
                                                                    className="hidden"
                                                                    value="job-seeking"
                                                                    checked={choosenHistoryType === "job-seeking"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="job-seeking" className={`option-one ${choosenHistoryType === "job-seeking" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Job Seeking</div>
                                                                </label>
                                                            </div>

                                                            <div className="history-outer">
                                                                <input type="radio"
                                                                    id="different-reason"
                                                                    name="choosen-history-type"
                                                                    value="different-reason"
                                                                    className='hidden'
                                                                    checked={choosenHistoryType === "different-reason"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="different-reason" className={`option-two ${choosenHistoryType === "different-reason" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">A Different Reason</div>
                                                                </label>
                                                            </div>

                                                        </div>
                                                    </Col>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={BackProfilePage}>Back</Button>
                                                                {/* <Button className='my-next-btn button-green float-end'>Next</Button> */}
                                                                <Button className='my-next-btn button-green float-end' onClick={HistoryFieldsTwo}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                                <Col md={2}></Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }


                                {
                                    historyTwo ?
                                        <Card.Body className='history-part-two-main'>
                                            <Row>
                                                <Col md={9} className='history-part-two-text-outer'>
                                                    <div className='history-part-two-text'>
                                                        <h2>Work Experience</h2>
                                                        <p>Detail your work experience, including job titles, companies, and dates of employment. Focus on your accomplishments and responsibilities in each role to showcase your skills and career progression effectively.</p>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <ChangeTemplateLayout />
                                                </Col>
                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={HistoryFieldsOne}>Back</Button>
                                                                <PreviewTemplate />
                                                                <Button className='my-next-btn button-green float-end' onClick={HistoryFieldsThree}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                                {
                                    historyThree ?
                                        <Card.Body className='history-part-three-main'>
                                            <Row>
                                                <Col md={12} className='history-part-three-text-outer'>
                                                    <div className='history-part-three-text'>
                                                        <h2>Tell me about your most recent job</h2>
                                                        <p>we will start there and work backword</p>
                                                    </div>
                                                </Col>
                                                <Col md={12} className='ps-0 mb-3'>
                                                    <Row>
                                                        <Col md={6}>
                                                            <div className="form-check no-experience-outer mb-4">
                                                                <input
                                                                    className="form-check-input no-experience"
                                                                    type="checkbox"
                                                                    value=""
                                                                    id="no-experience"
                                                                    onChange={handelFresher}
                                                                    checked={fresherData ? true : false}
                                                                />
                                                                <label className="form-check-label no-experience-label" htmlFor="no-experience">
                                                                    I am fresher ( No experience )
                                                                </label>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                <Col md={12}>
                                                    {
                                                        fresherData === true ? <p>Thank You. You have selected i am fresher. We will create a valuable resume for you!</p> :
                                                            loader ? <SpinLoader /> :
                                                                experience?.length > 0 ?
                                                                    experience?.map((field, index) => (

                                                                        <div className="row job-infromation-part" key={index}>

                                                                            <div className="col-md-6">
                                                                                <div className="mb-3">
                                                                                    <label className="form-label">Job Title<span className="fa fa-star requierd-star"></span></label>
                                                                                    <input
                                                                                        placeholder="Enter the job title"
                                                                                        type="text"
                                                                                        name="jobTitle"
                                                                                        className="form-control form-control-lg"
                                                                                        value={field.jobTitle}
                                                                                        onChange={(event) => handleChange(index, event)}
                                                                                    />
                                                                                    {
                                                                                        field?.errorJobTitleMsg ? <span className='text-danger'>{field?.errorJobTitleMsg}</span> : ''
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-md-6">
                                                                                <div className="mb-3">
                                                                                    <label className="form-label">Organization <span className="fa fa-star requierd-star"></span></label>
                                                                                    <input
                                                                                        placeholder="Enter the organization name"
                                                                                        type="text"
                                                                                        name="employer"
                                                                                        className="form-control form-control-lg"
                                                                                        value={field.employer}
                                                                                        onChange={(event) => handleChange(index, event)}
                                                                                    />
                                                                                    {
                                                                                        field?.errorEmployerMsg ? <span className='text-danger'>{field?.errorEmployerMsg}</span> : ''
                                                                                    }
                                                                                </div>

                                                                            </div>

                                                                            <div className="col-xl-6 col-md-12">
                                                                                <div className="mb-3">
                                                                                    <label className="form-label">Location <span className="fa fa-star requierd-star"></span></label>
                                                                                    <input
                                                                                        placeholder="Enter the location"
                                                                                        type="text"
                                                                                        name="location"
                                                                                        className="form-control form-control-lg"
                                                                                        value={field.location}
                                                                                        onChange={(event) => handleChange(index, event)}
                                                                                    />
                                                                                    {
                                                                                        field?.errorLocationMsg ? <span className='text-danger'>{field?.errorLocationMsg}</span> : ''
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-6 col-md-12">
                                                                                <div className="row form-align-items">
                                                                                    <div className="col-md-6">
                                                                                        <div className="mb-3">
                                                                                            <label className="form-label">Start Date <span className="fa fa-star requierd-star"></span></label>

                                                                                            <DatePicker
                                                                                                showIcon
                                                                                                icon={<i className="fa fa-calendar" aria-hidden="true"></i>}
                                                                                                toggleCalendarOnIconClick
                                                                                                selected={field.startDate ? moment(field.startDate).format('YYYY-MM-DD') : null}
                                                                                                onChange={(date) => handleChange(index, 'startDate', date)}
                                                                                                className="form-control form-control-lg"
                                                                                                placeholderText={'Select the start date'}
                                                                                                maxDate={new Date()}
                                                                                                name="startDate"
                                                                                                dateFormat="MM/dd/YYYY"
                                                                                                peekNextMonth
                                                                                                showMonthDropdown
                                                                                                showYearDropdown
                                                                                                dropdownMode="select"
                                                                                                onKeyDown={handleKeyDown}

                                                                                            />

                                                                                            {
                                                                                                field?.errorStartDateMsg ? <span className='text-danger'>{field?.errorStartDateMsg}</span> : ''
                                                                                            }
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6">
                                                                                        {
                                                                                            field.currentlyWorkHere === false ?
                                                                                                <div className="mb-3">
                                                                                                    <label className="form-label">End Date <span className="fa fa-star requierd-star"></span></label>

                                                                                                    <DatePicker
                                                                                                        showIcon
                                                                                                        icon={<i className="fa fa-calendar" aria-hidden="true"></i>}
                                                                                                        toggleCalendarOnIconClick
                                                                                                        selected={field?.endDate ? moment(field.endDate).format('YYYY-MM-DD') : null}
                                                                                                        onChange={(date) => handleChange(index, 'endDate', date)}
                                                                                                        className="form-control form-control-lg end-date-input"
                                                                                                        placeholderText="Select the end date"
                                                                                                        maxDate={new Date()}
                                                                                                        minDate={field?.startDate && moment(field?.startDate).add(1, 'day').toDate()}
                                                                                                        name="endDate"
                                                                                                        disabled={!field.startDate}
                                                                                                        dateFormat="MM/dd/YYYY"
                                                                                                        peekNextMonth
                                                                                                        showMonthDropdown
                                                                                                        showYearDropdown
                                                                                                        dropdownMode="select"
                                                                                                        onKeyDown={handleKeyDown}
                                                                                                    />
                                                                                                    {
                                                                                                        field?.errorEndDateMsg ? <span className='text-danger'>{field?.errorEndDateMsg}</span> : ''
                                                                                                    }
                                                                                                </div>

                                                                                                :

                                                                                                <div className="form-present-data-field">
                                                                                                    <span>Present</span>
                                                                                                </div>
                                                                                        }

                                                                                    </div>

                                                                                    <div className="col-md-12">
                                                                                        <div className="form-check float-end" >
                                                                                            <input
                                                                                                className="form-check-input currentlyWork"
                                                                                                type="checkbox"
                                                                                                name='currentlyWorkHere'
                                                                                                checked={field.currentlyWorkHere ? true : false}
                                                                                                onChange={(event) => handleChange(index, event)}
                                                                                            />
                                                                                            <label className="form-check-label" htmlFor="currentlyWork">
                                                                                                I currently work here
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                            <div className="col-md-12 responsive-experience-jd">
                                                                                <div className="mb-3">
                                                                                    <div className="col-md-12">
                                                                                        <label className="form-label">
                                                                                            Job Description
                                                                                            <span className="text-success"> ( You can add max 400 characters in Job Description field. )</span>
                                                                                        </label>
                                                                                        <textarea
                                                                                            name="jobDescription"
                                                                                            rows='3'
                                                                                            className="form-control form-control-lg"
                                                                                            value={field.jobDescription}
                                                                                            onChange={(event) => handleChange(index, event)}
                                                                                        >
                                                                                        </textarea>
                                                                                        {
                                                                                            field?.errorjobDescriptionMsg ? <span className='text-danger'>{field?.errorjobDescriptionMsg}</span> : ''
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {
                                                                                experience.length > 1 ?
                                                                                    <Button className='remove-experience-button' onClick={() => handelExperienceRemove(index)}><i className="fa fa-trash" aria-hidden="true"></i> </Button>
                                                                                    : ''
                                                                            }

                                                                        </div>
                                                                    ))
                                                                    :
                                                                    <>Click the <strong>Add Experience</strong> button to include your experience details here.
                                                                    </>
                                                    }

                                                    {
                                                        fresherData === false ?
                                                            <Row>
                                                                <Col md={12} className='mt-3'>
                                                                    <Button className='add-experience-button' onClick={handelExperienceAdd} ><i className="fa fa-plus" aria-hidden="true"></i> Add Experience</Button>
                                                                </Col>
                                                            </Row>
                                                            : ''
                                                    }

                                                </Col>
                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={HistoryFieldsTwo}>Back</Button>
                                                                <Button className='my-next-btn button-green float-end' onClick={MovetoEducationPage}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                            </Card>
                        </Col>

                    </Row>
                </Container>
            </section >
        </>
    )
}

export default History
